import React, { CSSProperties } from 'react';

export type ScrollableGridContainerContextValue = {
  scrollableGridContainer: {
    height: CSSProperties['height'];
  };
  scrollableChildContainer: {
    height: CSSProperties['height'];
  };
};

// Create a context with initial value as null
export const ScrollableGridContainerContext = React.createContext<
  ScrollableGridContainerContextValue | undefined
>(undefined);
